import React from "react";
import PreQCFactoryComponent from "../../../components/FactoryModule/PreQC/preqc.factory.component";

export default class PreQCFactoryScreen extends React.Component {
  render() {
    return <PreQCFactoryComponent />;
  }
}
